import React, { FC } from 'react';
import { useContext, createContext } from 'react';
import {useQuery} from "react-query";
import {SpinContainer} from "../components/SpinContainer";
import {DashboardProduct} from "../types";

type Feature = "user_engagement_with_avg_scores" | "no_activity_count_on_overview_page" | "avg_completion_time_on_overview_page";

export interface Organisation {
    id: number,
    name: string,
    logo_url?: string,
    products?: DashboardProduct[],
    labels: {[key:string]: string},
    features?: Feature[],
    minimum_students_for_analytics?: null | number,
    can_view_individual_data: boolean,
    can_view_user_pii: boolean,
}

export const OrganisationInformationContext = createContext<Organisation | undefined>(undefined);

export const OrganisationInformationProvider: FC = ({children}) => {
    const {data, isLoading} = useQuery<Organisation>('/organisation', {
        staleTime: Infinity,
    });

    return (
        isLoading
            ? <SpinContainer screenSize/>
            : <OrganisationInformationContext.Provider value={data}>
                {children}
            </OrganisationInformationContext.Provider>
    )
}

export const useOrganisation = () => {
    const organisation = useContext(OrganisationInformationContext);
    if(organisation === undefined){
        throw new Error('useOrganisation must be used within a OrganisationInformationProvider');
    }
    return organisation;
}
